@if (selectedCondition.showFieldDeletedWarning) {
  <p class="error-message">
    This field no longer exists. Remove it then click Save.
  </p>
}
<div class="filter-item" [class.sub-condition]="isSubCondition">
  @if (!hideAddRemove) {
    <p class="condition-prfx">
      <b>{{
        index == 0 ? (isSubCondition ? 'With' : 'Where') : conjunction
      }}</b>
    </p>
  }
  <div class="filter-query">
    <mat-form-field
      subscriptSizing="dynamic"
      class="condition-field extra-compact-field"
      appearance="outline"
      floatLabel="always"
      [class.mat-form-field-invalid]="
        selectedCondition.isFilterApplied && !selectedCondition.filter
      "
    >
      <input
        type="text"
        placeholder="Search conditions..."
        matInput
        [formControl]="myControl"
        [matAutocomplete]="auto"
        aria-label="Search for a condition"
      />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayFn"
        (optionSelected)="autocompleteSelectedChanged($event.option.value)"
      >
        @for (condition of availableConditions; track condition) {
          <mat-option [value]="condition">{{
            condition.displayName
          }}</mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>

    @if (selectedCondition.filter) {
      <div>
        <mat-form-field
          subscriptSizing="dynamic"
          appearance="outline"
          floatLabel="always"
          class="dropdown-field extra-compact-field"
          [class.mat-form-field-invalid]="
            selectedCondition.isFilterApplied &&
            !selectedCondition.filterOperator
          "
        >
          <mat-select
            [(ngModel)]="selectedCondition.filterOperator"
            (selectionChange)="onOperatorsSelectionChange()"
            aria-label="Select an operator"
          >
            @for (op of operators; track op) {
              <mat-option [value]="op">{{ op.displayName }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    }
    @if (
      selectedCondition.filter &&
      selectedCondition.filterOperator &&
      selectedCondition.filterOperator.isSearchValueNeeded
    ) {
      <div>
        @if (selectedCondition.uiType == uiType.Multiselect) {
          <multiselect
            [compactSize]="true"
            [items]="multiselectItems"
            [selectedItems]="selectedMultiselectItems"
            (selectionChanged)="multiselectSelectionChanged($event)"
            [placeholder]="'Select items...'"
            [required]="selectedCondition.isFilterApplied"
            [isTouched]="selectedCondition.isFilterApplied"
            aria-label="Select a value or values"
          ></multiselect>
        }
        @if (selectedCondition.uiType == uiType.DropDown) {
          <mat-form-field
            subscriptSizing="dynamic"
            appearance="outline"
            floatLabel="always"
            fxFlex
            class="dropdown-field extra-compact-field"
            [class.mat-form-field-invalid]="
              (selectedCondition.isFilterApplied ||
                selectedCondition.isSubFilterAdded) &&
              (selectedCondition.searchValue == null ||
                selectedCondition.searchValue.toString() == '')
            "
          >
            <mat-select
              [(ngModel)]="selectedCondition.searchValue"
              (selectionChange)="selectedCondition.isFilterApplied = false"
              aria-label="Select a value"
            >
              @if (selectedCondition.filter.valueType == 'List') {
                @for (value of selectedCondition.filter.values; track value) {
                  <mat-option [value]="value">{{ value }}</mat-option>
                }
              }
              @if (selectedCondition.filter.valueType == 'Boolean') {
                @for (value of selectedCondition.filter.values; track value) {
                  <mat-option [value]="value.searchValue">{{
                    value.name
                  }}</mat-option>
                }
              }
            </mat-select>
          </mat-form-field>
        }
        @if (
          selectedCondition.uiType == uiType.Textbox ||
          selectedCondition.uiType == uiType.DatePicker
        ) {
          <div class="inputs">
            @if (selectedCondition.uiType == uiType.Textbox) {
              <mat-form-field
                subscriptSizing="dynamic"
                class="extra-compact-field"
                appearance="outline"
                fxFlex
                [class.mat-form-field-invalid]="
                  (selectedCondition.isFilterApplied ||
                    selectedCondition.isSubFilterAdded) &&
                  !selectedCondition.searchValue
                "
              >
                <input
                  matInput
                  [type]="inputType"
                  [(ngModel)]="selectedCondition.searchValue"
                  (change)="
                    selectedCondition.searchValue =
                      selectedCondition.searchValue.trim()
                  "
                  (ngModelChange)="selectedCondition.isFilterApplied = false"
                  [placeholder]="textBoxPlaceholder"
                  aria-label="Type a value"
                />
              </mat-form-field>
            }
            @if (selectedCondition.uiType == uiType.DatePicker) {
              <mat-form-field
                subscriptSizing="dynamic"
                class="extra-compact-field"
                appearance="outline"
                fxFlex
                [class.mat-form-field-invalid]="
                  (selectedCondition.isFilterApplied ||
                    selectedCondition.isSubFilterAdded) &&
                  !selectedCondition.searchValue
                "
              >
                <input
                  matInput
                  [matDatepicker]="datePicker"
                  [(ngModel)]="selectedCondition.searchValue"
                  (ngModelChange)="selectedCondition.isFilterApplied = false"
                  aria-label="Select or type a date value"
                />
                <mat-datepicker-toggle matSuffix [for]="datePicker">
                </mat-datepicker-toggle>
                <mat-datepicker #datePicker></mat-datepicker>
              </mat-form-field>
            }
          </div>
        }
      </div>
    }
  </div>
  @if (showAddSubConditionButton) {
    <button
      mat-icon-button
      color="primary"
      (click)="addSubCondition.emit()"
      aria-label="Add Sub-Condition"
    >
      <mat-icon>add_circle</mat-icon>
    </button>
  }
  @if (!hideAddRemove) {
    <button
      mat-icon-button
      color="primary"
      (click)="onDelete()"
      aria-label="Delete condition"
    >
      <mat-icon>delete</mat-icon>
    </button>
  }
</div>
